import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useAppSelector } from "../../../hooks";
import { useWebFramed } from "../../../hooks/useWebFramed";
import { brandSelector } from "../../../redux/slices/Brand/brand";
import { searchSelector } from "../../../redux/slices/Search/search";
import HotelSearchModal from "../HotelSearchModal/HotelSearchModal";
import GlobalSearch from "../Search/GlobalSearch/GlobalSearch";
import MobileGlobalSearchSummary from "../Search/MobileGlobalSearchSummary/MobileGlobalSearchSummary";
import {
  BrandStripe,
  Header,
  SearchWrapper,
  StickyContainer,
} from "./SearchBarHelpers";
import { ISearchBarProps } from "./SearchBarProps";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";
import { useSearchSliceContext } from "../../../context/SliceContexts/SearchContext";
import { ScrollVisibilityProvider } from "../../../context/scrollVisibilityContext";
const SearchBar: React.FC<ISearchBarProps> = () => {
  const { location, isHotelPage, showEditSearch, onShowEditSearch } =
    useSearchSliceContext();
  const search = useAppSelector(searchSelector);
  const isWebFramed = useWebFramed();
  const brand = useAppSelector(brandSelector);
  const searchString = search.searchString;
  const isHomepage =
    typeof window !== "undefined" &&
    window.location.pathname == "/" &&
    isWebFramed;
  const [locationFocus, setLocationFocus] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { isMobileOnly } = useMobileDetectContext();
  const [showHotelSearchModal, setShowHotelSearchModal] = React.useState(
    !!isHomepage
  );
  const logo = brand?.relationships?.field_brand_stripe_logo?.publicUrl || "";

  const theme = {
    color: brand?.field_color?.color || "",
    logo: logo,
    alt: brand?.field_logo_alt_text || brand?.name || "Sonesta Hotels",
    linkPath: brand?.path?.alias || "/",
  };
  const showLogo = !!logo && location.pathname !== "/checkout" && !isWebFramed;
  const handleEditSearch = () => {
    if (isMobile) {
      setShowHotelSearchModal(true);
      !searchString && setLocationFocus(true);
      onShowEditSearch && onShowEditSearch(false);
    }
  };

  const handleOnSearchSubmit = () => {
    if (isMobile && !isHomepage) {
      setShowHotelSearchModal(false);
    }
  };
  useEffect(() => {
    setShowHotelSearchModal(!!isHomepage);
  }, [isHomepage]);
  useEffect(() => {
    showEditSearch && handleEditSearch();
  }, [showEditSearch]);
  useEffect(() => {
    setIsMobile(isMobileOnly);
  }, [isMobileOnly]);

  const redLionPaths = [
    "/hotel-rl",
    "/red-lion-hotels",
    "/red-lion-inn-suites",
    "/guesthouse-extended-stay",
    "/knights-inn",
  ];
  const signatureInn = ["/signature"];
  const sonestaInca = ["/sonesta-posadas-del-inca"];
  const canadasBest = ["/canadas-best-value-inn"];
  const americasBest = ["/americas-best-value-inn"];

  let logoClass = "logo";
  if (signatureInn.includes(theme.linkPath)) {
    logoClass = "logo-signature-inn";
  }
  if (sonestaInca.includes(theme.linkPath)) {
    logoClass = "logo-sonesta-inca";
  }
  if (canadasBest.includes(theme.linkPath)) {
    logoClass = "canadas-best";
  }
  if (americasBest.includes(theme.linkPath)) {
    logoClass = "americas-best";
  }
  if (redLionPaths.includes(theme.linkPath)) {
    logoClass = "logo-redlion";
  }
  return (
    <ScrollVisibilityProvider>
      <StickyContainer>
        <Header color={theme.color}>
          <Container fluid="sm">
            <Row className="px-lg-0 px-sm-0">
              <SearchWrapper>
                <div className={`desktop-view ${showLogo ? "align-logo" : ""}`}>
                  {showLogo && (
                    <Col lg={2} className={`search-logo d-block`}>
                      <img
                        src={theme.logo}
                        className={logoClass}
                        alt={theme.alt}
                      />
                    </Col>
                  )}
                  <Col
                    className={`d-flex flex-column justify-content-center ${
                      showLogo ? "col-lg-10" : "col"
                    } ${isMobile ? "d-none" : ""}`}
                  >
                    <GlobalSearch
                      location={location}
                      isHotelPage={isHotelPage}
                      locationFocus={locationFocus}
                      onSubmit={handleOnSearchSubmit}
                      isLogo={showLogo}
                    />
                  </Col>
                </div>
                <div className={`mobile-view ${showLogo ? "logo-space" : ""}`}>
                  <Col>
                    <HotelSearchModal
                      show={isMobile ? showHotelSearchModal : false}
                      onHide={handleOnSearchSubmit}
                      location={location}
                      isHotelPage={isHotelPage}
                    />
                  </Col>
                  {!showHotelSearchModal ? (
                    <Col className="d-flex flex-column px-1 px-md-3">
                      <MobileGlobalSearchSummary
                        onEdit={handleEditSearch}
                        theme={theme}
                        showLogo={showLogo}
                      />
                    </Col>
                  ) : null}
                </div>
              </SearchWrapper>
            </Row>
          </Container>
        </Header>
        {showLogo ? (
          <Col>
            <BrandStripe
              brandStripeColor={
                `${brand?.field_brand_stripe_color?.color}` || ""
              }
            >
              {" "}
            </BrandStripe>
          </Col>
        ) : (
          ""
        )}
      </StickyContainer>
    </ScrollVisibilityProvider>
  );
};

export default SearchBar;
